import { CircularProgress, Grid } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import PageLayout from "examples/LayoutContainers/PageLayout";

export default function BasePageLoader({
  layout = "dashboard",
}: {
  layout?: "dashboard" | "page";
}) {
  const Wrapper = layout === "dashboard" ? DashboardLayout : PageLayout;

  return (
    <Wrapper>
      <Grid container spacing={5}>
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Grid>
      </Grid>
    </Wrapper>
  );
}
